<template>
    <Teleport to="#sports">
        <div class="comboParlayInfo" v-on:click.self="emit('close')">
            <div class="comboParlayInfo-content">
                <h3 class="comboParlayInfo-title">
                    {{ getTranslationBySite('betSlip_comboParlay_info_title') }}
                </h3>
                <ol class="comboParlayInfo-list">
                    <li>{{ getTranslationBySite('betSlip_comboParlay_info_content_1') }}</li>
                    <li>
                        {{ getTranslationBySite('betSlip_comboParlay_info_content_2') }}
                        <span class="comboParlayInfo-example">
                            {{ i18n.t('betSlip_comboParlay_info_content_2_1') }}
                        </span>
                        <span class="comboParlayInfo-example">
                            {{ i18n.t('betSlip_comboParlay_info_content_2_2') }}
                        </span>
                    </li>
                    <li>
                        {{ i18n.t('betSlip_comboParlay_info_content_3') }}
                    </li>
                </ol>
                <button
                    class="comboParlayInfo-gotIt"
                    type="button"
                    v-on:click="emit('close')"
                >
                    {{ i18n.t('betSlip_comboParlay_info_gotIt') }}
                </button>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
    import { getTranslationBySite } from '@/libraries/helpers/i18nHelper';
    import { i18n } from '@/libraries/i18n';

    const emit = defineEmits<{
        close: [];
    }>();
</script>

<style lang="scss" scoped>
@import "@/scss/components/comboParlayInfoPopup";
</style>
